import { render, staticRenderFns } from "./AccountSetup.vue?vue&type=template&id=fbaa4cd0&scoped=true&"
import script from "./AccountSetup.vue?vue&type=script&lang=js&"
export * from "./AccountSetup.vue?vue&type=script&lang=js&"
import style0 from "./AccountSetup.vue?vue&type=style&index=0&id=fbaa4cd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbaa4cd0",
  null
  
)

export default component.exports